<template>
    <div>
        <b-modal id="scanModal" scrollable size="lg" @hide="clear">
            <template #modal-title>
                <span v-if="scanIn" class="text-success">
                    <feather-icon icon="AlertCircleIcon" />
                    Lager ind
                </span>
                <span v-else class="text-danger">
                    <feather-icon icon="AlertCircleIcon" />
                    Lager ud
                </span>
            </template>
            <b-card-text>

                <b-row>
                    <b-col cols="12" md="4" lg="3">
                        <FormGroup label="Antal" rules="">
                            <template #input>
                                <b-form-spinbutton v-model="scan.amount" min="1" :disabled="loading"></b-form-spinbutton>
                            </template>
                        </FormGroup>
                    </b-col>
                    <b-col cols="12" md="8" lg="9">
                        <FormGroup label="Stregkode" rules="">
                            <template #input>
                                <b-form-input ref="ean" v-model="scan.ean" @keypress.enter="scanProduct" :disabled="loading"></b-form-input>
                            </template>
                        </FormGroup>
                    </b-col>
                </b-row>

                <hr v-if="items.length > 0" class="mb-25" />

                <div class="alert alert-danger" v-if="fails > 0">
                    <div class="alert-body text-center">{{fails}} fejl ved lageropdatering! Følgende blev ikke opdateret.</div>
                </div>
                <div class="alert alert-success" v-if="success">
                    <div class="alert-body text-center">Lageropdatering gennemført!</div>
                </div>


                <b-row v-for="(item, key) in items" :key="key" class="mb-10">
                    <b-col cols="12" md="4" lg="3">
                        <FormGroup no-label rules="" class="m-0">
                            <template #input>
                                <b-form-spinbutton v-model="item.amount" min="1" :disabled="loading"></b-form-spinbutton>
                            </template>
                        </FormGroup>
                    </b-col>
                    <b-col class="d-flex" style="align-items: center">
                        <span class="d-block font-weight-bold">{{item.name}}</span>
                    </b-col>
                    <b-col cols="12" md="3" lg="2" class="d-flex text-right" style="align-items: center; justify-content: flex-end;">
                        DKK {{item.price}}
                        <feather-icon icon="XCircleIcon" class="ml-10 text-danger" size="18" @click="removeProduct(key)" />
                    </b-col>
                </b-row>
            </b-card-text>

            <template #modal-footer="{ cancel }">
                <span class="font-weight-bolder" v-if="!scanIn">Total: DKK {{totalPrice}}</span>

                <b-button variant="outline-secondary" class="py-7 px-15" @click="cancel" :disabled="loading">
                    Annuller
                </b-button>

                <b-button variant="success" class="py-7 px-15" @click="confirmScan" :disabled="loading">
                    <b-spinner v-if="loading" small></b-spinner>
                    Godkend
                </b-button>
            </template>
        </b-modal>

        <b-modal id="scanProductModal" title="Find produkt" scrollable size="md">
            <template #modal-title>
                <span class="text-danger">
                    <feather-icon icon="AlertTriangleIcon" size="13" />
                    Produkt blev ikke fundet!
                </span>
            </template>

            <FormGroup label="Tilknyt til produkt" rules="">
                <template #input>
                    <v-select v-model="product" :options="products" @search="fetchProducts" placeholder="Find produkt" :filterable="false" append-to-body>
                        <template slot="option" slot-scope="option">
                            <span class="d-block font-weight-bold">{{ option.name }}</span>
                            <small class="d-block">{{ option.sku }}</small>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            {{ option.name }}
                        </template>
                    </v-select>
                </template>
            </FormGroup>


            <template #modal-footer>
                <b-button variant="outline-secondary" class="py-7 px-15" @click="cancelProduct" :disabled="loading">
                    Annuller
                </b-button>

                <b-button variant="success" class="py-7 px-15" @click="confirmProduct" :disabled="loading">
                    <b-spinner v-if="loading" small></b-spinner>
                    Godkend
                </b-button>
            </template>

        </b-modal>
    </div>
</template>

<script>
    export default {
        components: {},
        data: () => ({
            loading: false,
            scan: {
                amount: 1,
                ean: ""
            },
            items: [],
            products: [],
            product: null,
            totalPrice: 0,
            fails: 0,
            success: false
        }),
        computed: {},
        props: ["scanIn"],
        watch: {
            items: {
                handler() {
                    this.totalPrice = this.items.reduce((sum, x) => sum + (x.price * x.amount), 0)
                },
                deep: true
            }
        },
        created() { },
        mounted() { },
        methods: {
            scanProduct(e) {
                this.loading = true
                this.$http.post("/api/stock/scan", this.scan).then(x => {
                    this.loading = false
                    if (x.data === false) {
                        this.$bvModal.show("scanProductModal")
                    } else {
                        this.items.push(x.data)
                        this.scan = {
                            amount: 1,
                            ean: ""
                        }
                        setTimeout(() => {
                            this.$refs.ean.focus()
                        }, 100)
                    }
                })
            },
            removeProduct(key) {
                this.items.splice(key, 1)
            },
            confirmScan() {
                if (this.items.length == 0) {
                    this.$bvModal.hide("scanModal")
                    return
                }

                this.loading = true
                this.$http.post("/api/stock/scan/confirm", { items: this.items, scanIn: this.scanIn }).then(x => {
                    this.loading = false

                    this.fails = x.data.fails.length
                    this.items = x.data.fails

                    if (this.fails == 0) {
                        this.success = true
                    }
                })
            },


            confirmProduct() {
                this.loading = true
                this.product.gtin = this.scan.ean

                this.$http.post("/api/stock/update-product", this.product).then(x => {
                    this.loading = false
                    this.$bvModal.hide("scanProductModal")

                    this.items.push({ ...this.scan, name: x.data.name, price: x.data.price })

                    this.product = null
                    this.scan = {
                        amount: 1,
                        ean: ""
                    }
                    setTimeout(() => {
                        this.$refs.ean.focus()
                    }, 100)
                })
            },
            cancelProduct() {
                this.$bvModal.hide("scanProductModal")
                this.product = null
                this.scan = {
                    amount: 1,
                    ean: ""
                }
            },
            fetchProducts(search, loading) {
                loading(true)

                this.$http.get("/api/stock/find-products", {
                    params: {
                        search: search
                    }
                }).then(x => {
                    this.products = x.data
                    loading(false)
                })
            },

            clear() {
                this.fails = 0
                this.items = []
                this.success = false
            }
        },
    }
</script>